import React from 'react';

const Contact = () => (
  <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-[#EFF6FF] via-white to-[#F9FAFB]">
    <section className="w-full max-w-7xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-blue-700 text-center">Contact Us</h2>
        <form className="bg-white p-4 sm:p-6 rounded-lg shadow-md space-y-4">
          <input 
            type="text" 
            placeholder="Your Name" 
            className="w-full px-3 sm:px-4 py-2 sm:py-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base" 
          />
          <input 
            type="email" 
            placeholder="Your Email" 
            className="w-full px-3 sm:px-4 py-2 sm:py-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base" 
          />
          <textarea 
            placeholder="Your Message" 
            className="w-full px-3 sm:px-4 py-2 sm:py-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base" 
            rows="4"
          ></textarea>
          <button 
            type="submit" 
            className="w-full bg-blue-600 text-white py-2 sm:py-3 rounded hover:bg-blue-700 transition text-sm sm:text-base font-semibold"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  </div>
);

export default Contact; 